/* esm.sh - d3-transition@3.0.1/src/interrupt */
export * from "/*d3-transition@3.0.1/esnext/src/interrupt.mjs";
export { default } from "/*d3-transition@3.0.1/esnext/src/interrupt.mjs";
